import { lazy } from 'react';

const User = lazy(() => import('components/Users/Details'));
const Vehicle = lazy(() => import('components/Vehicles/Details'));
const ReservationDriver = lazy(() => import('components/Reservations/Details'));
const ConditionalInstance = lazy(() => import('components/Alarms/Details'));

export { Vehicle, User, ReservationDriver, ConditionalInstance };
